import _defineProperty from "/Volumes/United_T7/projects/careersv2/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { hasWindow, isProduction } from "@rpldy/shared";
import { unwrap, isProxiable, isProxy } from "@rpldy/simple-state";
import { DEFAULT_OPTIONS } from "./defaults";
var FILE_LIST_SUPPORT = hasWindow() && "FileList" in window;

var getMandatoryDestination = function getMandatoryDestination(dest) {
  return _objectSpread({
    params: {}
  }, dest);
};

var getMandatoryOptions = function getMandatoryOptions(options) {
  return _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options), {}, {
    destination: options && options.destination ? getMandatoryDestination(options.destination) : null
  });
};

var getIsFileList = function getIsFileList(files) {
  return (//in case files list was created in a different context(window) need to check toString
    FILE_LIST_SUPPORT && files instanceof FileList || files.toString() === "[object FileList]"
  );
};
/***
 * will unwrap object from proxy
 * if obj itself isnt a proxy, will look for a proxy max 2 levels deep
 */


var deepProxyUnwrap = function deepProxyUnwrap(obj) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var result = obj;

  if (!isProduction()) {
    if (level < 3 && isProxy(obj)) {
      result = unwrap(obj);
    } else if (level < 3 && isProxiable(obj)) {
      result = Array.isArray(obj) ? obj.map(function (sub) {
        return deepProxyUnwrap(sub, level + 1);
      }) : Object.keys(obj).reduce(function (res, key) {
        res[key] = deepProxyUnwrap(obj[key], level + 1);
        return res;
      }, {});
    }
  }

  return result;
};

export { getMandatoryOptions, getIsFileList, deepProxyUnwrap };